import React, { useEffect, useState } from "react";
import { Skill_Type } from "../model";
import Loading from "../components/Loading";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const SkillsPage = () => {
  const [skills, setSkills] = useState<Skill_Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      collection(db, "skills"),
      (snapshot) => {
        const data: Skill_Type[] = snapshot.docs.map(
          (doc) => doc.data() as Skill_Type
        );
        setSkills(data.sort((a, b) => b.proficiency - a.proficiency));
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Skills{" "}
          <sup className="text-gray-500 text-sm font-normal">
            {skills.length} and more skills
          </sup>
        </h1>
        {!skills.length && loading && <Loading />}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="bg-white overflow-hidden shadow rounded-lg relative group flex flex-col justify-between hover:scale-[1.02] transition-all duration-300"
            >
              <div className="p-4">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {skill.name}
                </h2>
                <div className="relative pt-1"></div>
                <div className="bg-gray-800 p-2 rounded-lg">
                  <code className="text-white whitespace-pre-line">
                    {skill.code}
                  </code>
                </div>
              </div>
              <div className="flex flex-col items-start justify-between bg-gray-100 px-4 py-2 group-hover:bg-gray-200 transition duration-300">
                <div className="flex shadow-md w-full overflow-hidden h-3 mb-4 text-xs rounded bg-white">
                  <div
                    className=" bg-blue-500"
                    style={{ width: `${skill.proficiency}%` }}
                  ></div>
                </div>
                <span className="text-sm font-medium text-gray-500">
                  {skill.proficiency}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillsPage;
